import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  updateListOfColors,
  getOrderUpDisplayColor, getChecksList
} from '@reducers/orderUp';
import {
  getCubbyLayoult,
} from '@reducers/cubby';
import { setNotification } from '@reducers/notification';
import { LABEL } from '../../veriables';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import styles from './orderUp.module.scss';
import TextAutoScroll from '@components/common/TextAutoScroll';
import {
  getStoreChecks,
  subscribeToStoreChecks,
  authenticate,
} from '../../sockets/communicator';
import { getObjectValue } from '@utility/utills';
import {
  setInActivityStatus
} from '@reducers/oauth';

const useInterval = (callback, delay, parameter) => {
  const savedCallback = useRef();
  const [color, setColor] = useState(callback() || 'bg-white');
  const intervalId = useRef(null);
  const clear = useCallback(() => clearInterval(intervalId.current), []);
  const timer = () => {
    const result = savedCallback.current();
    setColor(result);
    if (intervalId.current && !result) {
      clear();
    }
  };
  savedCallback.current = callback;
  useEffect(() => {
    if (intervalId.current) {
      clear();
    }

    if (delay) {
      intervalId.current = setInterval(timer, delay);
    }
    return () => {
      clear();
    };
  }, [parameter]);

  return [color];
};

const orderStatusColorConfig = (orderStatusId, pickupStatusId) => {
  let label = '';
  let bgColor = '';
  let color = '';
  if (orderStatusId === 1) {
    color = 'color-gray';
    bgColor = 'bg-yellow';
    label = LABEL().PREPARING;
  }
  if (orderStatusId === 5 && pickupStatusId !== 3) {
    color = 'color-white';
    bgColor = 'bg-green';
    label = LABEL().READY;
  }
  if (orderStatusId === 5 && pickupStatusId === 3) {
    color = 'color-white';
    bgColor = 'bg-lightblue';
    label = LABEL().SEE_COUNTER;
  }
  return { bgColor, label, color };
};
const RenderComp = ({
  check,
  index,
  deviceInfo,
  auth,
  updateColors,
  type,
  listOfColors,
  cubbyLayoultHashTable,
  currentPage
}) => {
  const [style] = useInterval(() => {
    const date = (check?.orders[0]?.completedDate || check?.orders[0]?.pickupDate || check?.orders[0]?.orderDate);
    const color = getOrderUpDisplayColor(date, deviceInfo?.deviceGroup, auth.prepWindow, type, (check?.orders?.length > 0 && check?.orders[0]));
    return color;
  }, 1000, check);

  useEffect(() => {
    updateColors({
      id: check?.id,
      color: style,
      type,
      index,
      currentPage
    });
  }, [style]);
  return (
    <div
      id={check?.id}
      className={cn('w-100 rounded d-flex flex-column h-100', listOfColors[check?.id]?.color || 'bg-white')}
    >
      <div className="h-100 d-flex flex-column py-2 px-1 col-12 text-center text-capitalize color-black">
        <div className="h-40 overflowY">
          <TextAutoScroll className="fs-24 py-1 fw-600 text-uppercase">{`${(check?.orders[0]?.checkInNote || check.name || check.stationName || check.stationNumber || '')}`}</TextAutoScroll>
          <div className="fs-16 py-1">{LABEL().ORDER} #{check.number}</div>
          {check.deliver && !check.marketplace && (
            <>
              <TextAutoScroll className="fs-14 py-1">{(check?.orders[0]?.deliveryVendorName || '')}</TextAutoScroll>
              <TextAutoScroll className="fs-14 py-1">{(check?.orders[0]?.externalOrderNumber || '')}</TextAutoScroll>
            </>
          )}
          {check.marketplace && (
            <>
              <TextAutoScroll className="fs-14 py-1">{(check?.orders[0]?.marketplaceVendorName || '')}</TextAutoScroll>
              <TextAutoScroll className="fs-14 py-1">{(check?.orders[0]?.marketplaceOrderId || '')}</TextAutoScroll>
            </>
          )}
        </div>
        <div className={cn('p-1 mt-auto d-flex align-items-end justify-content-center w-100 lh-normal h-60')}>
          {type === 0 && cubbyLayoultHashTable[check?.orders[0]?.storeCubbySlotId]?.name && (
            <div className="text-center fs-60 fw-600 color-darkgreen">
              <div className="w-100 fs-18 fw-600 color-black">{LABEL().CUBBY}</div>
              {cubbyLayoultHashTable[check?.orders[0]?.storeCubbySlotId]?.name}
            </div>
          )}
          {type === 1 && (
            <div className={cn('text-center rounded', orderStatusColorConfig(check?.orders[0]?.orderStatusId, check?.orders[0].pickUpStatus)?.bgColor)}>
              <div className={cn('w-100 fs-22 fw-600 py-2', orderStatusColorConfig(check?.orders[0]?.orderStatusId, check?.orders[0].pickUpStatus)?.color)}>{orderStatusColorConfig(check?.orders[0]?.orderStatusId, check?.orders[0].pickUpStatus)?.label}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const OrderUp = ({
  auth,
  checkListHashTable,
  deviceInfo,
  readyOrderChecks,
  listOfColors,
  cubbyLayoultHashTable,
  socketConnected,
  totalOrderCount,
  lastSocketUpdateTime,
  ...props
}) => {
  const intervalId = useRef(null);
  const {
    rowCount, columnCount, orderUpDisplaySequence,
    primaryOrderUpDisplayColumnCount, primaryOrderUpDisplayRowCount
  } = deviceInfo;
  const [currentPage, setCurrentPage] = useState(() => Number(orderUpDisplaySequence) || 1);
  const storeId = auth.id;
  useEffect(() => {
    if (storeId) {
  }
  }, [storeId]);
  const listRef = useRef(null);
  let count = 1;
  const type = deviceInfo?.deviceGroup?.startMode || 0;

  const refreshChecks = () => {
    props.getChecksList({
      checkListHashTable,
      deviceInfo,
      auth,
      type,
    }).then((list) => {
      listRef.current = list;
      if ((!orderUpDisplaySequence || Number(orderUpDisplaySequence) === 0) && Object.keys(listRef.current)?.length > 0) {
        if (intervalId.current) {
          clearInterval(intervalId.current);
        }
        intervalId.current = setInterval(() => {
          const length = Object.keys(listRef.current).length;
          if (length === 0) {
            clearInterval(intervalId.current);
            setCurrentPage(1);
          }
          count += 1;
          if ((count - 1) >= (length)) {
            count = 1;
          }
          setCurrentPage(count);
        }, 5000);
      }
    });
  };

  const updateColors = (data) => {
    props.updateListOfColors({ ...data, deviceInfo }).then((list) => {
      listRef.current = list;
    });
  };

  const getDisplayStyle = () => {
    let height = 50;
    let width = 25;
    if (columnCount && rowCount) {
      width = Number(orderUpDisplaySequence) === 1 && primaryOrderUpDisplayColumnCount ? 100 / primaryOrderUpDisplayColumnCount : 100 / columnCount;
      height = Number(orderUpDisplaySequence) === 1 && primaryOrderUpDisplayRowCount ? 100 / primaryOrderUpDisplayRowCount : 100 / rowCount;
    }
    return { height: `${height}%`, width: `${width}%` };
  };

  useEffect(() => {
    if (checkListHashTable) {
      refreshChecks();
    }
  }, [checkListHashTable]);
  useEffect(() => {
    if (auth && socketConnected) {
      authenticate({ headers: { 'api-key': auth.syncApiKey }, id: getObjectValue(() => auth.id, 0) });
      subscribeToStoreChecks(auth.id);
      getStoreChecks(auth.id);
    }
  }, [socketConnected]);

  return (
    <div className={cn('col-12 h-100 w-100 px-1 py-1 bg-black color-white row mx-0 align-items-start')}>
      {props.loading && <Loader />}
      {socketConnected ? (
        <>
          {((Number(orderUpDisplaySequence) > 0 && currentPage === 1) || !orderUpDisplaySequence || Number(orderUpDisplaySequence) === 0) && (
            <div className={cn('p-2 fw-600 fs-50 row mx-0 align-items-center text-left col-3 h-100')}>
              {(deviceInfo?.deviceGroup?.startMode === 1) ? LABEL().ORDER_STATUS : LABEL().READY_TO_PICKUP}
              {/* <div className="mt-auto fs-16 w-100">
                <div className="w-100">{LABEL().SOCKET_STATUS}: {socketConnected ? LABEL().CONNECTED : LABEL().DISCONNECTED}</div>
                <div className="w-100">{LABEL().LAST_UPDATED_TIME}: {lastSocketUpdateTime || ''}</div>
                <div className="w-100">{LABEL().TOTAL_CHECKS}: {totalOrderCount}</div>
                {(!orderUpDisplaySequence || Number(orderUpDisplaySequence) === 0) && <div className="w-100">{LABEL().PAGE}: {currentPage} of {Object.keys(readyOrderChecks).length || 1}</div>}
              </div> */}
            </div>
          )}
          <div className={cn('row mx-0 px-0 w-100 rounded p-1 overflowY bg-black h-100 align-content-start', ((Number(orderUpDisplaySequence) > 0 && currentPage === 1) || !orderUpDisplaySequence || Number(orderUpDisplaySequence) === 0) ? 'col-9' : 'col-12')}>
            {readyOrderChecks[currentPage]?.map((check, index) => {
              return (
                <div key={check?.id} className={cn('p-2', styles.card)} style={{ height: getDisplayStyle().height, width: getDisplayStyle().width }}>
                  <RenderComp
                    check={check}
                    index={index}
                    deviceInfo={deviceInfo}
                    updateColors={updateColors}
                    listOfColors={listOfColors}
                    type={type}
                    cubbyLayoultHashTable={cubbyLayoultHashTable}
                    auth={auth}
                    currentPage={currentPage}
                  />
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className={cn('p-2 fw-600 fs-50 d-flex flex-column mx-0 justify-content-center text-left col-4 h-100')}>
          {LABEL().CONNECTING_TO_NEWTWORK}
          <div className={cn(styles.animationStripes, 'bg-lightblue')} />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  getChecksList,
  updateListOfColors,
  getCubbyLayoult,
  setInActivityStatus
}, dispatch);

const mapStateToProps = ({
  orderUp, oauth, storeChecks,
  // cubby
}) => ({
  loading: orderUp.loading || storeChecks.loading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  checkListHashTable: storeChecks.checkListHashTable,
  readyOrderChecks: orderUp.readyOrderChecks,
  listOfColors: orderUp.listOfColors,
  cubbyLayoultHashTable: orderUp.cubbyLayoultHashTable,
  socketConnected: oauth.socketConnected,
  totalOrderCount: orderUp.totalOrderCount,
  lastCheckTime: orderUp.lastCheckTime,
  lastSocketUpdateTime: storeChecks.lastSocketUpdateTime,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderUp);
